/* istanbul ignore file */
import {
    RECEIVE_RATES,
    REQUEST_RATES,
    SET_RATES,
} from './types'

export function requestRates (params) {
    return {
        type: REQUEST_RATES,
        ...params,
    }
}

export function receiveRates (
    rates,
    status = {status: 'success', error: null}) {
    return {
        type: RECEIVE_RATES,
        rates,
        status,
    }
}

export function setRates (Rates) {
    return {
        type: SET_RATES,
        Rates,
    }
}
